var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPasskeyGooglePasswordManager24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7.41)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 3.33835H13.0909V5.84186H18V3.33848V3.33835Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.18C2.02503 9.18 0 7.11452 0 4.59007C0 2.06561 2.02503 0 4.5 0C6.97497 0 9 2.06561 9 4.59007C9 7.11452 6.97497 9.18 4.5 9.18ZM4.5 2.50364C3.37497 2.50377 2.45455 3.44252 2.45455 4.59007C2.45455 5.73761 3.37497 6.67649 4.5 6.67649C5.62503 6.67649 6.54545 5.73761 6.54545 4.59007C6.54545 3.44252 5.62503 2.50364 4.5 2.50364Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 5.84194H13.0909V8.34557H14.7272V7.5109C14.7272 7.05193 15.0953 6.67648 15.5454 6.67648C15.9955 6.67648 16.3636 7.05193 16.3636 7.5109V8.34557H18V5.84181H16.3636V5.84194Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8363 3.33832H6.1363C6.38176 3.69295 6.54539 4.11016 6.54539 4.59007C6.54539 5.06998 6.38176 5.48719 6.1363 5.84195H8.8363C8.93854 5.44543 8.99994 5.02822 8.99994 4.59007C8.99994 4.15192 8.93854 3.73471 8.8363 3.33819V3.33832Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0908 3.33834H8.8363C8.93854 3.73473 8.99994 4.15194 8.99994 4.59009C8.99994 5.02824 8.93854 5.44545 8.8363 5.84197H13.0908V3.33808V3.33834Z",
    fill: "#FBBC04"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 9.18,
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasskeyGooglePasswordManager24);
export default __webpack_public_path__ + "static/media/icon-passkey-google-password-manager-24.48a2cada164bea539a73321f69e631eb.svg";
export { ForwardRef as ReactComponent };